<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="400">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          שם מלא
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.FullName" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          תעודת זהות
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Identity" />
        </v-flex>
      </v-layout>
      <v-layout v-if="!isEntrepreneur" row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          שם משתמש
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Username" />
        </v-flex>
      </v-layout>
      <v-layout v-if="!isEntrepreneur" row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          סיסמה
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Password" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs4 right>
        </v-flex>
        <v-flex xs3>
          <input type="checkbox" v-model="$parent.popup.data.Active" class="w3-check"> פעיל
        </v-flex>
        <v-flex xs3 v-if="!isEntrepreneur">
          <input type="checkbox" v-model="$parent.popup.data.Approved" class="w3-check"> מאושר
        </v-flex>
      </v-layout>
      <v-flex row wrap style="padding: 10px 10px 10px 10px;">
        <span class="error" v-show="error">* {{error}}</span>
      </v-flex>
      <v-flex actions style="padding: 20px 10px 10px 10px;">
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: 'PopupUser',
    data() {
      return {
        error: ''
      }
    },
    created() {
      this.$Log("Vue [PopupUser] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupUser] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupUser] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupUser] is updated ...");
    },
    computed: {
      isEntrepreneur() {
        return (this.$parent.popup.data.Type == "יזם");
      }
    },
    methods: {
      isValid() {
        if (this.$parent.popup.data.FullName.trim().length <= 0) return false;
        if (!this.isEntrepreneur && this.$parent.popup.data.Username.trim().length <= 0) return false;
        if (this.$parent.popup.data.Identity.trim().length <= 0) return false;
        if (this.$parent.popup.data.Type.trim().length <= 0) return false;
        if (!this.isEntrepreneur && this.$parent.popup.data.Password.trim().length <= 0) return false;
        return true;
      },
      save() {
        this.error = "";
        if (this.isValid()) {
          if (this.$parent.popup.isEdit) {
            this.$parent.update();
          }
          else {
            this.$parent.insert();
          }
          this.reset();
        }
        else {
          this.error = "נא למלא את כל השדות!"
        }
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
        };
      }
    }
  }

</script>
<style>
  .error {
    color: red;
    background-color: #fff !important;
  }
</style>



// WEBPACK FOOTER //
// PopupUser.vue?f1a8e0d4